<template>
  <div class="flex flex-1 min-h-0 w-full flex-col items-center justify-evenly gap-[2vmin] py-[1vmin]">
    <p
      class="max-w-[92vmin] shrink-0 text-center text-white/85 font-medium tracking-wide px-[2vmin]"
      :style="instructionStyle"
      role="status"
    >
      {{ unpairedHeadline }}
    </p>
    <p
      class="max-w-[92vmin] shrink-0 text-center text-white/70 leading-snug tracking-wide px-[2vmin]"
      :style="instructionStyle"
    >
      Lucimark — plataforma de telas digitais. Esta tela está pronta para receber conteúdo.
    </p>

    <div
      class="bg-white rounded-2xl shadow-2xl shrink-0"
      :style="{ padding: qrCardPadding }"
    >
      <div
        class="flex items-center justify-center"
        :style="qrBoxStyle"
      >
        <div
          ref="qrcodeEl"
          class="qrcode-block flex w-full items-center justify-center"
          role="img"
          :aria-label="registrationCode ? 'QR code para registo do leitor' : undefined"
        />
      </div>
    </div>

    <div
      class="min-h-[1.1em] w-full shrink-0 flex items-center justify-center font-black tracking-[0.08em] tabular-nums text-white leading-none"
      :style="registrationCodeStyle"
      aria-live="polite"
    >
      {{ registrationCode ?? '' }}
    </div>

    <p
      class="max-w-[92vmin] shrink-0 text-center text-white/55 leading-snug tracking-wide px-[2vmin]"
      :style="instructionStyle"
    >
      Escaneie o QR code ou acesse
      <span class="text-white/85">{{ typedPairingUrl }}</span>
      para registrar este dispositivo — grátis para começar
    </p>
  </div>
</template>

<script lang="ts" setup>
import { playerGlassStateHeadline } from '@lucimark/shared/helpers/playerGlassState'
import QRCode from 'qrcode'
import { computed, ref, toRefs, unref, watch } from 'vue'
import usePlayer from '@/composables/usePlayer'
import {
  REGISTRATION_QR_CARD_PADDING,
  registrationCodeTextStyle,
  registrationInstructionTextStyle,
  registrationQrBoxStyle
} from '@/helpers/playerRegistrationIdleLayout'
import { buildPlayerPairingTypedUrl } from '@/helpers/playerPairingTypedUrl'

const qrCardPadding = REGISTRATION_QR_CARD_PADDING

const { state } = usePlayer()
const { registrationCode, appURL, screenOrientation } = toRefs(state)

const qrBoxStyle = computed(() => registrationQrBoxStyle(screenOrientation.value))
const registrationCodeStyle = computed(() => registrationCodeTextStyle(screenOrientation.value))
const instructionStyle = computed(() => registrationInstructionTextStyle(screenOrientation.value))
const typedPairingUrl = computed(() => buildPlayerPairingTypedUrl(registrationCode.value))
const unpairedHeadline = playerGlassStateHeadline('unpaired', 'pt')

const qrcodeEl = ref<null | HTMLElement>(null)
const qrcodeCanva = ref('')

watch(
  registrationCode,
  async (code) => {
    try {
      const url
        = code === null ? 'https://lucimark.com' : `${unref(appURL)}/register-player/${code}`
      qrcodeCanva.value = await QRCode.toString(url, {
        color: { dark: '#000000ff', light: '#ffffffff' }
      })
    }
    catch {
      qrcodeCanva.value = ''
    }
  },
  { immediate: true }
)
watch(
  [qrcodeEl, qrcodeCanva],
  ([el, canva]) => {
    if (el !== null) {
      el.innerHTML = canva
    }
  },
  { immediate: true }
)
</script>

<style scoped>
.qrcode-block :deep(svg) {
  width: 100%;
  height: auto;
  display: block;
}
</style>
